import { useState, useEffect } from 'react';

export const MOBILE_BREAKPOINT = 768;

/**
 * 画面幅がモバイルサイズかどうかを判定するフック
 * CSSのメディアクエリ @media (max-width: 768px) と同期
 */
export function useIsMobile(): boolean {
  // SSR対応のため、初期値はtypeof windowで判定
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }
    return false;
  });

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    checkIsMobile();

    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  return isMobile;
}
